import styled from 'styled-components';

export const Footer = styled.footer`
  // height: 100%;
  background-color: ${({ theme }) => theme.theme.colors.header} !important;
`;
